import {TextField} from '@material-ui/core'
import {Autocomplete} from '@material-ui/lab/';
import {useState, useEffect} from 'react'
import UserService from '../services/UserService';

const Buddies = ({
    form: { setFieldValue, setFieldTouched },
    field: { value: values, name},
    variant,
    disabled,
    label,
    ...rest
}) => {
    const [options, setOptions]= useState([])
    const [search, setSearch]= useState('')

    useEffect(() => {
        const getOptions= async () => {
            const response = await UserService.buddies(search)
            setOptions(response.data)
        }
        const timeoutid= setTimeout(() => {
            if (search && search.length > 2) getOptions()
        }, 500)
        return () => clearTimeout(timeoutid)
    }
    , [search])

    return (
        <Autocomplete
            onChange={(event,val) => setFieldValue(name,val)}
            disableClearable
            value={values||null}
            //defaultValue={values||null}
            isOptionEqualToValue={(option,value) => option.id === value.id}
            multiple={true}
            id={label}
            getOptionLabel={option => `${option.fullname} (${option.username})`}
            getOptionKey={option => option.id}
            options={options}
            disabled={disabled}
            noOptionsText='Geen personen gevonden, type meer dan 2 letters'
            renderInput={(params) => <TextField {...params} label={label} variant={variant} onChange={e=> setSearch(e.target.value) } />}
        />
    )
}

export default Buddies